function closeCardCompares() {
	if (document.querySelector('.compares-cards__wrapper--one') != null) {
		let parentElement = document.querySelectorAll('.compares-cards__wrapper--one')
		let specCounter = 0
		parentElement.forEach(def => {
			let slides = def.querySelectorAll('.compares__slide')
			let cardArray = new Array()
			let descArray = new Array()
			slides.forEach(el => {
				if (el.classList.contains('compares__slide--desc')) {
					descArray.push(el)
				} else {
					cardArray.push(el)
				}
			})
			cardArray.forEach((item, id) => {
				let btnClose = item.querySelector('.Card-product__btn-delete-js')
        if (btnClose) {
				btnClose.onclick = () => {
					if (specCounter != (slides.length / 2) - 2) {
						def.removeChild(item)
						specCounter++
					} else {
						def.removeChild(item)
						def.querySelector('.Card-product__btn-delete-js').style.display = 'none'
					}
				}
        }
			})
		})
	}
}
